<template>
<div>
    <div class="op">
<div class="add">
  <el-input v-model="admin" size="mini" clearable placeholder="系统管理员姓名"></el-input>
</div>
<div class="add">
    <el-select size="mini" clearable  v-model="admin" placeholder="客服姓名">
    <el-option
      v-for="item in adminList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</div>
<div class="add">
  <el-input v-model="idcard" size="mini" clearable placeholder="请输入身份证号"></el-input>
</div>
<div class="add">
    <el-select size="mini" clearable  v-model="opera" placeholder="操作类型">
    <el-option
      v-for="item in operaList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</div>
<div class="add">
    <el-date-picker
      v-model="time"
      size='mini'
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
</div>
<el-button type="primary" size="mini" style="background:#148A9B;margin-left:10px" icon="el-icon-search" @click="serch">搜索</el-button>
</div>
<div class="tb">
    <el-table
    :data="tableData"
    style="width: 100%"
    stripe>
    <el-table-column
      prop="admin"
      label="管理员"
      width="180">
    </el-table-column>
    <el-table-column
      prop="idCard"
      label="身份证号"
     >
    </el-table-column>
     <el-table-column
      prop="operate"
       width="310"
      label="操作">
    </el-table-column>
      <el-table-column
      prop="userIp"
       width="130"
      label="IP">
    </el-table-column>
    <el-table-column
      prop="endTime"
      label="操作时间">
    </el-table-column>
  </el-table>
</div>
<div class="rrr">
    <el-pagination
  	class="pone"
      :page-size='10'
      layout="total, prev, pager, next, jumper"
      :total="totals"
      :current-page.sync="Page"
      @current-change="current_change"
>
    </el-pagination>
</div>
</div>
</template>
<script>
import {formatDate} from '../../utils/datetimeYMR'
import CryptoJS from 'crypto-js'
export default{
    data(){
        return{
            Page:1,
            totals:0,
            time:'',
            idcard:"",
            admin:'',
            opera:'',
            tableData:[],
            adminList:[{
                label:"邓亚凝",
                value:'dengyaling'
            },{
                label:"李非凡",
                value:'service_lff'
            },{
                label:"尹璐瑶",
                value:'service_yly'
            },{
                label:"李圆圆",
                value:'service_lyy'
            }],
            operaList:[{
                label:"修改参保信息",
                value:'1'
            },{
                label:"修改个人信息",
                value:'2'
            },{
                label:"新增个人信息",
                value:'3'
            },{
                label:"导出认证记录",
                value:'4'
            },{
                label:"认证审核记录",
                value:'5'
            },{
                label:"修改个人状态",
                value:'6'
            },{
                label:"新增认证记录",
                 value:'7'
            },{
                label:"导出个人基础信息",
                value:'8'
            },{
                label:"删除个人基础信息",
                value:'9'
            },{
                label:"照片复核",
                value:'10'
            },{
              label:"认证时间设置",
              value:'11'
            }]
        }
    },
    methods:{
        current_change(s){
            this.Page=s
        this.serchPage(s)
        },
          Encrypt(word) { //aes加密
				var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
				let srcs = CryptoJS.enc.Utf8.parse(word);
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				});
				return encrypted.toString();
			},
        serch(){
             this.serchPage(this.Page)
        },
        serchPage(s){
            let data={
                admin:this.admin,
                idCard:this.idcard?this.Encrypt(this.idcard):'',
                operate:this.opera,
                beginTime:formatDate(this.time[0]),
                endTime:formatDate(this.time[1]),
                pageNum:s,
                pageSize:10
            }
            this.$api.getlist.logQuery(data).then(res=>{
                if(res.code==200){
                this.tableData=res.data.list
                this.totals=res.data.page.total_count
                }else{

                    this.$message({
                        type:"warning",
                        message:res.message
                    })
                    this.tableData=[]
                    this.totals=0
                }
            }).catch(err=>{

            })
        }
    }

}
</script>
<style>
.op{
    display: flex
}
.add{
    margin-left: 10px
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/logQuery.vue